import "./related-dynamic-yield-content-block.scss";

// @ts-check
(function () {
    const block = document.querySelectorAll(".js-related-dy-content-block");

    if (block.length === 0) {
        return;
    }

    const tpWaitForSelectorVisible = function (e, callback) {
        let tpCheckSpeed = 200;
        const tpChecker = function () {
            const el = document.querySelector(e);
            if (tpCheckSpeed > 800) {//waited around 20 seconds, lets stop.
            } else if (el && el.offsetParent) {
                callback();
                //console.log('found')
            } else {
                setTimeout(function () {
                    tpCheckSpeed = tpCheckSpeed + 15;
                    tpChecker();                    
                }, tpCheckSpeed);
            }
        }
        tpChecker();
    }

    const matcher = window.matchMedia("(max-width: 800px)");
    const contentHeader = document.querySelector(".header__container");
    const carousel = contentHeader.nextElementSibling;
    const carouselContainer = block[0];
    const carouselContainerStyle = carouselContainer.style;
    const contentHeaderStyle = contentHeader.style;
    const controls = carouselContainer.querySelector(".controls");
    let recommandationsCarousel = document.querySelector(".cards__container.recommandations__carousel");

    const leftControl = controls?.querySelector(".left-control");
    const rightControl = controls?.querySelector(".right-control");

    const cards = [];

    for (const card of carousel.children) {
        cards.push(card);
    }

    let cardWidth = 0;
    const card = carousel.querySelector(".card__feature");
    if (card) {
        cardWidth = card.offsetWidth;
    } 
    let isDesktop = false;
    let pageWidth = document.body.getBoundingClientRect().width;

    const toggleSwipeButtons = () => {
        rightControl.classList.remove("arrow-disabled");
        rightControl.classList.add("arrow-enabled");
        leftControl.classList.remove("arrow-disabled");
        leftControl.classList.add("arrow-enabled");

        if (recommandationsCarousel?.scrollLeft === 0) {
            leftControl.classList.remove("arrow-enabled");
            leftControl.classList.add("arrow-disabled");
            rightControl.classList.remove("arrow-disabled");
            rightControl.classList.add("arrow-enabled");
        }

        if (recommandationsCarousel?.scrollWidth === recommandationsCarousel?.getBoundingClientRect().width + recommandationsCarousel?.scrollLeft) {
            rightControl.classList.remove("arrow-enabled");
            rightControl.classList.add("arrow-disabled");
            leftControl.classList.remove("arrow-disabled");
            leftControl.classList.add("arrow-enabled");
        }
    }

    const swipeRight = () => {
        const carouselContainer = document.querySelector(".cards__container.recommandations__carousel").parentElement;
        cardWidth = document.querySelector(".card.card__feature").clientWidth + 16;
        const cardNumber = cardIndex + Math.ceil(carouselContainer.clientWidth / cardWidth) - 1;
        card__feature__click(cardNumber)
    }

    const swipeLeft = () => {
        const carouselContainer = document.querySelector(".cards__container.recommandations__carousel").parentElement;
        cardWidth = document.querySelector(".card.card__feature").clientWidth + 16;
        card__feature__click(Math.ceil(Math.min(cardIndex - carouselContainer.clientWidth / cardWidth) - 1, cardIndex))
    }
    tpWaitForSelectorVisible(".cards__container.recommandations__carousel", () => {
        recommandationsCarousel = document.querySelector(".cards__container.recommandations__carousel");
        if (recommandationsCarousel?.scrollWidth === recommandationsCarousel?.clientWidth) {
            controls.style.display = "none"
        } else {
            if (leftControl) {
                leftControl.addEventListener("click", swipeLeft)
            }
            if (rightControl) {
                rightControl.addEventListener("click", swipeRight)
            }
            toggleSwipeButtons();
        }
    })

    function handleMatch() {
        isDesktop = !matcher.matches;
        pageWidth = document.body.getBoundingClientRect().width;

        if (!isDesktop) {
            controls.style.display = "none";
            carouselContainer.style = "padding: 0px";
            contentHeader.style = "margin: auto var(--spacing__36)";
        } else {
            const card = carousel.querySelector(".card__feature");
            if (card) {
                cardWidth = card.offsetWidth + 16;
            }
            controls.style.display = "flex";
            carouselContainer.style = carouselContainerStyle;
            contentHeader.style = contentHeaderStyle;
        }
    }

    handleMatch();
    matcher.addEventListener("change", handleMatch)

    let activeCardIndex = 0;
    let animateScrollId;
    carousel.classList.add("recommandations__carousel");

    carousel.querySelectorAll("p").forEach(function (p) {
        p.classList.add("recommandations__carousel__minimizedText");
    });

    const indicator = document.createElement("div");
    indicator.classList.add("recommandations__carousel__indicator");
    carousel.after(indicator);

    function card__feature__carousel(card) {
        let scale = 0.9;
        cardWidth = document.querySelector(".card.card__feature").clientWidth + (isDesktop ? 16 : 0);

        const xCard = card.getBoundingClientRect().x - 36

        if (xCard > -cardWidth && xCard < cardWidth) {
            scale += ((cardWidth - Math.abs(xCard)) / cardWidth) * 0.1;
        }

        if (!isDesktop) {
            scale = Math.min(scale, 1);
            card.style.transform = "scale(" + scale + ")";
            card.style.opacity = (((scale - 0.8) * 5)).toString();
        }

        return scale;
    }

    function scrollTo(element, to, duration) {
        if (animateScrollId) {
            cancelAnimationFrame(animateScrollId);
            animateScrollId = null;
        }

        const start = element.scrollLeft || 0;
        const change = to - start;
        let currentTime = 0;
        const increment = 20;

        const animateScroll = (cb) => () => {
            currentTime += increment;
            const val = easeInOutQuad(currentTime, start, change, duration);
            element.scrollTo({ left: val });

            maxScale = 0;
            cards.forEach(function (card, index) {
                const scale = card__feature__carousel(card);
                if (scale >= maxScale) {
                    maxScale = scale;
                    cardIndex = index;
                }
                bullets[index].classList.remove("active");
            }, this);

            bullets[cardIndex].classList.add("active");

            if (currentTime < duration) {
                animateScrollId = requestAnimationFrame(animateScroll(cb));
            } else {
                animateScrollId = null;
                if (cb) cb();
            }

        }
        animateScrollId = requestAnimationFrame(animateScroll(toggleSwipeButtons));
    }

    function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }

    function card__feature__click(index) {
        cardWidth = document.querySelector(".card.card__feature").clientWidth + (isDesktop ? 16 : 0);
        activeCardIndex = index;
        const scrollLeft = ((cardWidth) * index);
        scrollTo(carousel, scrollLeft, 600);
        lastKnownScrollPosition = scrollLeft;
        cards.forEach(card__feature__carousel);
    }

    let lastKnownScrollPosition = 0;
    let maxScale = 0;
    let cardIndex = 0;
    let xStart = 0;
    let yStart = 0;
    let isScrolling = false;
    let pageScrollLock = false;

    cards.forEach(function (card, index) {
        card__feature__carousel(card);

        card.addEventListener("click", function (card) {
            if (activeCardIndex !== index) card.preventDefault();
            card__feature__click(index);
        });

        const bullet = document.createElement("span");
        bullet.className = "bullet" + (index === 0 ? " active" : "");
        indicator.append(bullet);
    }, this);

    const bullets = document.querySelectorAll(
        ".recommandations__carousel__indicator .bullet"
    );

    let handleTouchStart = function (event) {
        xStart = event.touches ? event.touches[0].pageX : event.pageX;
        yStart = event.touches ? event.touches[0].pageY : event.pageY;
        isScrolling = true;
        lastKnownScrollPosition = carousel.scrollLeft;
    }

    let handleTouchMove = function (event) {
        const xEnd = event.changedTouches ? event.changedTouches[0].pageX : event.pageX;
        const yEnd = event.changedTouches ? event.changedTouches[0].pageY : event.pageY;
        const delta = xEnd - xStart;
        const pageDelta = yEnd - yStart;

        if (Math.abs(delta) > 3 && Math.abs(pageDelta) < 5) {
            pageScrollLock = true;
            document.addEventListener("touchmove", disablePageScroll, { passive: false, once: true });
            document.body.classList.add("stop-scrolling");
        }

        if (!isScrolling || !xEnd) return;

        if (!isDesktop) {
            if (delta > pageWidth / 3) {
                // Swipe right
                xStart = xEnd
                if (activeCardIndex > 0) {
                    isScrolling = false;
                    card__feature__click(Math.max(activeCardIndex - 1, 0));
                }
            } else if (-delta > pageWidth / 3) {
                // Swipe left
                xStart = xEnd;
                if (activeCardIndex < cards.length) {
                    isScrolling = false;
                    card__feature__click(Math.min(activeCardIndex + 1, cards.length - 1))
                }
            } else {
                carousel.scrollTo({ left: lastKnownScrollPosition - delta })
            }
        } else {
            carousel.scrollTo({ left: lastKnownScrollPosition - delta })
        }
    }

    let handleTouchEnd = function (event) {
        document.removeEventListener("touchmove", disablePageScroll, true);
        document.body.classList.remove("stop-scrolling");
        pageScrollLock = false;
        const pageX = event.changedTouches ? event.changedTouches[0].pageX : event.pageX;

        if (!isDesktop) {
            if (pageX !== xStart && isScrolling) {
                card__feature__click(cardIndex)
            }
        } else {
            const recommandationsCarousel = document.querySelector(".cards__container.recommandations__carousel");

            const lastCardAddition = recommandationsCarousel.clientWidth + recommandationsCarousel.scrollLeft === recommandationsCarousel.scrollWidth ? 1 : 0;
            const _cardIndex = Math.round(recommandationsCarousel.scrollLeft / cardWidth) + lastCardAddition;
            card__feature__click(_cardIndex)
        }
    }

    handleTouchStart = handleTouchStart.bind(this);
    handleTouchMove = handleTouchMove.bind(this);
    handleTouchEnd = handleTouchEnd.bind(this);

    carousel.addEventListener("touchstart", handleTouchStart);
    carousel.addEventListener("touchmove", handleTouchMove);
    carousel.addEventListener("touchend", handleTouchEnd);

    carousel.addEventListener("dragstart", handleTouchStart);
    carousel.addEventListener("drag", handleTouchMove);
    carousel.addEventListener("dragend", handleTouchEnd);

    let disablePageScroll = function (event) {
        if (pageScrollLock) {
            event.preventDefault();
        }
    }

    disablePageScroll = disablePageScroll.bind(this);

})();
